import { Schema } from '@bingads-webui-react/overreact';

import { edm } from './edm';

const schemaToModelMapping = {
  customer: 'Model/Customer',
  account: 'Model/Account',
  campaign: 'Model/Campaign',
  ad_group: 'Model/AdGroup',
  ad_extension_association: 'Model/AdExtensionAssociation',
  search_phrase: 'Model/SearchPhrase',
  campaign_criterion: 'Model/CampaignCriterion',
  performance_time_series: 'Model/PerformanceTimeSeries',
  alert_information: 'Model/AlertInformation',
  ad: 'Model/Ad',
  business: 'Model/Business',
  smart_listing: 'Model/SmartListing',
  kpi_estimations: 'Model/BudgetKpiEstimationsResponse',
  editorial_reasons: 'Model/EntityEditorialReasonsCollection',
};

export const schema = new Schema(schemaToModelMapping, name => edm.schema.schemas[name]);
